import { deserialize } from 'cerialize'
import moment from 'moment'
import { DATE_AND_TIME_FORMAT_REVERSE } from 'Constants/Global'

export class BgEventsLogModel {
	@deserialize public id: number
	@deserialize public fullname?: string
	@deserialize public email?: string
	@deserialize public object_id: number
	@deserialize public created_at: string
	@deserialize public external_id: string
	@deserialize public event?: string
	@deserialize public event_type: string
	@deserialize public failure_reason?: string
	@deserialize public status?: string
	@deserialize public initiator_roles?: any
	@deserialize public data?: string

	public get time_formatted(): string | undefined {
		return moment(this?.created_at).format(DATE_AND_TIME_FORMAT_REVERSE)
	}

	public get subject(): string {
		return `${this.fullname ?? ''} ${this.email ?? ''}`
	}
}
